import { useEffect } from "react";
import { Link } from "./router";
import { HELP_ANSWERS, WVCEA_EMAIL } from "./help-content";
import { associationPresentation } from "./association-presentation";

/**
 * What the question mark in the corner opens. Short answers, each with the button
 * that does the thing, so nobody has to go and find the screen being described.
 */
export function HelpPage({ eventName }: { eventName: string }) {
  const presentation = associationPresentation();
  useEffect(() => {
    document.title = `Help · ${eventName}`;
  }, [eventName]);

  if (!presentation.wvcea) return <div className="page help-page">
    <div className="page-intro"><h1 data-page-heading tabIndex={-1}>Help</h1><p>{presentation.appName} has not published its help details yet.</p></div>
  </div>;
  return (
    <div className="page help-page">
      <div className="page-intro">
        <h1 data-page-heading tabIndex={-1}>Help</h1>
        <p>The things people ask most, and how to reach us.</p>
      </div>
      <div className="help-list">
        {HELP_ANSWERS.map((entry) => (
          <section key={entry.question}>
            <h2>{entry.question}</h2>
            <p>{entry.answer}</p>
            {entry.action && (entry.action.external
              ? <a className="help-action" href={entry.action.href}>{entry.action.label}<b aria-hidden="true">›</b></a>
              : <Link className="help-action" href={entry.action.href}>{entry.action.label}<b aria-hidden="true">›</b></Link>)}
          </section>
        ))}
      </div>
      <p className="help-foot">
        Anything else, write to <a href={`mailto:${WVCEA_EMAIL}`}>{WVCEA_EMAIL}</a>. A person reads it.
      </p>
    </div>
  );
}
